import { useQuery } from '@tanstack/react-query';

import { individualsService, Individual } from '@aslanpay/portal-common-lib';

const NIL_UUID = '00000000-0000-0000-0000-000000000000';

export const fetchIndividualQuery = (id?: string, enabled = true) => ({
  queryKey: ['fetchIndividual', id],
  queryFn: async () => {
    const individual = await individualsService.fetchIndividual(id || '');

    const status =
      individual.status === 'ACTIVE' && individual.terminationDate ? 'LEAVING' : individual.status;

    return { ...individual, status };
  },
  enabled: !!id && id !== NIL_UUID && enabled,
});

const useFetchIndividual = (id?: string, enabled = true) => {
  return useQuery<Individual, Error>(fetchIndividualQuery(id, enabled));
};

export default useFetchIndividual;
